import React from "react";
import { useNavigate } from "react-router-dom";

// ArrowUndoUpLeft icon component
export function ArrowUndoUpLeft(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      {...props}
    >
      <path
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M11 7H6a4 4 0 0 0 0 8h7"
      />
      <polyline
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        points="8 11 11 7 15 11"
      />
    </svg>
  );
}

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="flex items-center justify-center min-h-screen bg-[#DEE9FC] px-4 relative">
      <div className="max-w-4xl w-full flex flex-col items-center relative">
        {/* Top Text */}
        <p className="custom-heading absolute top-8 left-1/2 transform -translate-x-1/2 text-center font-bold px-2">
          404 <br />
          We&apos;re working on it!
        </p>

        {/* Image */}
        <img
          src="/404-notFound.png"
          alt="404 Not Found Illustration"
          className="max-h-[70vh] sm:max-h-[80vh] md:max-h-[100vh] w-auto object-contain"
        />

        {/* Button */}
        <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 text-center px-1">
          <button
            onClick={() => navigate("/",{state:{qr_login_completed:1}})}
            className="inline-flex items-center gap-2 px-6 py-3 mt-4 rounded-full bg-[#e05a07] text-white border border-white hover:bg-[#cf4d04] transition-all text-lg custom-button"
          >
            <ArrowUndoUpLeft className="w-5 h-5 text-white" />
            Go Home
          </button>
        </div>
      </div>

      {/* Custom Styles */}
      <style>{`
        .custom-heading {
          line-height: 1;
          color: #e05a07;
          text-shadow: 0 0 5px rgba(0, 0, 0, 0.7);
          font-size: 2.5rem; /* Default font size */
          margin-bottom: 0;
        }

        @media (max-width: 767px) {
          .custom-heading {
            font-size: 1.75rem !important;
            top: 3rem !important;
            padding: 0 10px;
          }

          .custom-button {
            padding: 6px 12px !important;
            font-size: 0.875rem !important;
          }
        }

        @media (max-width: 480px) {
          .custom-heading {
            font-size: 0.5rem !important;
            top: 2rem !important;
          }

          .custom-button {
            padding: 4px 10px !important;
            font-size: 0.75rem !important;
          }
        }
      `}</style>
    </div>
  );
};

export default NotFound;























// import React from 'react';
// import { useNavigate } from 'react-router-dom';

// const NotFound = () => {
//   const navigate = useNavigate();

//   return (
//     <div className="flex flex-col items-center justify-center h-screen bg-gray-50 text-center">
//       <h1 className="text-6xl font-bold text-gray-800 mb-4">404</h1>
//       <p className="text-xl text-gray-600 mb-8">
//         Oops! The page you are looking for does not exist.
//       </p>
//       <button onClick={() => navigate('/')} className="bg-[#0B214E] py-2 px-8 text-white rounded-3xl">
//         Go to Homepage
//       </button>
//     </div>
//   );
// };

// export default NotFound;